<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <span *ngIf="!mergeQuoteMsg">{{ 'quoteTracking.quoteStatus' | cxTranslate }}</span>
          <span *ngIf="mergeQuoteMsg">{{ 'quoteTracking.mergeQuotes' | cxTranslate }}</span>
        </div>
      </div>
      <div class="cx-dialog-body modal-body">
        <div *ngIf="!warningMsg && !mergeQuoteMsg">
          {{ 'quoteTracking.saveCart2' | cxTranslate }}
        </div>
        <div *ngIf="warningMsg && !mergeQuoteMsg">
          {{ 'quoteTracking.warningMsg' | cxTranslate }}
        </div>
        <div *ngIf="mergeQuoteMsg && !warningMsg">
          {{ 'quoteTracking.mergeQuotePrompt' | cxTranslate }}
        </div>
        <div class="row mt-30">
          <div class="col-3"></div>
          <div class="col-9">
            <div class="row">
              <div *ngIf="warningMsg" class="col-sm-8 col-md-8"></div>
              <div class="col-sm-4 col-md-4">
                <button
                  cxAutoFocus
                  class="vs-text-btn"
                  (click)="closeModal('close')"
                >
                  {{ 'quoteTracking.cancel' | cxTranslate }}
                </button>
              </div>
              <div *ngIf="!warningMsg && !mergeQuoteMsg" class="col-sm-8 col-md-8">
                <button
                  cxAutoFocus
                  class="vs-primary-btn"
                  (click)="closeModal('merge-quote-edit')"
                >
                  {{ 'quoteTracking.proceedToCheckout2' | cxTranslate }}
                </button>
              </div>

              <div *ngIf="!warningMsg && mergeQuoteMsg" class="col-sm-8 col-md-8">
                <button
                  cxAutoFocus
                  class="vs-primary-btn"
                  (click)="closeModal('merge-quote')"
                >
                  {{ 'quoteTracking.proceedToCheckout2' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  